export const humildadypaciencia = {
	nombre: "Humildad y Paciencia",
	dia: "Domingo de Ramos",
	nombrecompleto:
		"Venerable, Inmemorial, Pontificia y Nacional Cofradía del Santísimo Cristo de la Humildad y Paciencia y Nuestra Señora de la Amargura",
	sede: "Iglesia de San Agustín",
	pasos: 1,
	distancia: [618, 1200],
	penitentes: 220,
	cargadores: 60,
	web: "http://www.diariodecadiz.es/semana_santa/Humildad_0_1229277795.html",
	ida: [
		{ lng: -6.2940663, lat: 36.5322369 },
		{ lng: -6.2939698, lat: 36.5322897 },
		{ lng: -6.2937203, lat: 36.5319653 },
		{ lng: -6.2924798, lat: 36.5306097 },
		{ lng: -6.2922075, lat: 36.5302864 },
		{ lng: -6.2928338, lat: 36.5297831 },
		{ lng: -6.293031, lat: 36.5298165 },
		{ lng: -6.293271, lat: 36.5297422 },
		{ lng: -6.2936077, lat: 36.5297055 },
		{ lng: -6.2937914, lat: 36.5297034 },
		{ lng: -6.2945182, lat: 36.5296332 },
		{ lng: -6.2946121, lat: 36.5295536 },
		{ lng: -6.2948683, lat: 36.5296161 },
		{ lng: -6.2950695, lat: 36.5296258 },
		{ lng: -6.2950695, lat: 36.5296258 },
		{ lng: -6.2950695, lat: 36.5296258 },
		{ lng: -6.2952787, lat: 36.5290277 },
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.2956944, lat: 36.5291053 },
		{ lng: -6.2954235, lat: 36.529767 },
		{ lng: -6.295673, lat: 36.5299545 },
		{ lng: -6.295276, lat: 36.5303543 },
		{ lng: -6.2950158, lat: 36.5308403 },
		{ lng: -6.2949353, lat: 36.5308403 },
		{ lng: -6.2949219, lat: 36.5314632 },
		{ lng: -6.2964642, lat: 36.5317746 },
		{ lng: -6.2964159, lat: 36.5318554 },
		{ lng: -6.2965769, lat: 36.5321151 },
		{ lng: -6.2967941, lat: 36.5325343 },
		{ lng: -6.2964199, lat: 36.5329341 },
		{ lng: -6.2962765, lat: 36.533239 },
		{ lng: -6.2963328, lat: 36.5332875 },
		{ lng: -6.2962724, lat: 36.5339513 },
		{ lng: -6.2967753, lat: 36.5341959 },
		{ lng: -6.2964454, lat: 36.5344319 },
		{ lng: -6.2963301, lat: 36.5343134 },
		{ lng: -6.2961102, lat: 36.5344287 },
		{ lng: -6.2958151, lat: 36.5344028 },
		{ lng: -6.2940717, lat: 36.5323856 },
		{ lng: -6.2940019, lat: 36.5323058 },
		{ lng: -6.2940985, lat: 36.5322541 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-25T19:10",
			latlng: [36.53228, -6.294076]
		},
		{
			name: "Nueva",
			hora: "2018-03-25T19:25",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-25T20:25",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-25T20:45",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-25T21:25",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-25T21:50",
			latlng: [36.53266, -6.29667]
		}
	],
	itinerario: [
		["Plaza San Agustín", "San Francisco (dcha.)", "Nueva"],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pío XII",
			"Estación de Penitencia en la S.I.C"
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañés", "Palillero"],
		["Novena", "Valverde"],
		[
			"San Pedro (izq.)",
			"Sagasta (dcha.)",
			"Tinte",
			"Plaza San Francisco",
			"Plaza de San Agustín"
		]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/humildadypaciencia.js